"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "18",
  height: "14",
  viewBox: "0 0 18 14"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16.9999 0.3C16.9999 0.2 16.8999 0.1 16.7999 0C16.5999 0 16.3999 0 16.1999 0C16.1999 0 2.19994 5 1.39994 5.6C1.09994 5.8 1.09994 5.9 0.999936 5.9C0.899936 6.3 1.29994 6.5 1.29994 6.5L4.89994 7.7C4.99994 7.7 4.99994 7.7 5.09994 7.7C5.89994 7.2 13.3999 2.5 13.7999 2.3C13.8999 2.3 13.8999 2.3 13.8999 2.3C13.6999 2.9 7.29994 8.6 7.29994 8.7C7.29994 8.7 7.19994 8.8 7.29994 8.8L6.99994 12.3C6.99994 12.3 6.89994 13.4 7.99994 12.3C8.79994 11.5 9.49994 10.9 9.89994 10.6C11.0999 11.5 12.4999 12.4 13.0999 12.9C13.2999 13.1 13.5999 13.2 13.7999 13.2C14.0999 13.2 14.3999 12.9 14.4999 12.6C14.4999 12.6 17.0999 2.3 17.0999 0.9C17.0999 0.8 17.0999 0.7 17.0999 0.6C16.9999 0.5 16.9999 0.4 16.9999 0.3Z"
}));

exports["default"] = _default;